<script setup lang="ts">
// biome-ignore lint/correctness/noUnusedImports: Vue parsing is broken.
import { getTranslation } from '../helpers/translations.helper.js';

const deliveryAddressType = defineModel<string>('deliveryAddressType', {
  default: 'woonadres',
});
</script>

<template>
  <y-input-wrapper>
    <label slot="label">{{ getTranslation('label_addressType') }}</label>
    <y-radio-button-group>
      <label class="order-form__input-radio-label">
        <input type="radio" name="delivery-address" value="home" v-model="deliveryAddressType" />

        <span>{{ getTranslation('addressType_living') }}</span>
      </label>

      <label class="order-form__input-radio-label">
        <input type="radio" name="delivery-address" value="company" v-model="deliveryAddressType" />
        <span>{{ getTranslation('addressType_business') }}</span>
      </label>

      <label class="order-form__input-radio-label">
        <input type="radio" name="delivery-address" value="funeralParlor" v-model="deliveryAddressType" />
        <span>{{ getTranslation('addressType_funeral') }}</span>
      </label>
    </y-radio-button-group>
  </y-input-wrapper>
</template>
